<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>

		<Content class="app-content__main">
			<QueryCondition @query="query" ref="queryCondition" />

			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
	
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/MemberOrderrQueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	import {
		LINK_TYPES
	} from '../../config/constants'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				queryParams: {},
				loading: false,
				queryData: [],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				deneyShow: false,
				denyCheckData: {

				},
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					}, {
						title: '用户ID',
						width: 200,
						key: 'userId',
						align: 'center'
					}, {
						title: '商品类目ID',
						width: 200,
						key: 'goodCatalogId',
						align: 'center'
					},
					{
						title: '商品标题',
						width: 200,
						key: 'title',
						align: 'center'
					},
					{
						title: '商品介绍',
						width: 200,
						key: 'intro',
						align: 'center'
					},
					{
						title: '支付金额',
						width: 200,
						key: 'payAmount',
						align: 'center'
					},
					{
						title: '图片',
						key: 'img',
						align: 'center',
						width: 200,
					}, {
						title: '支付状态',
						width: 200,
						align: 'center',
						render: (h, params) => {
							let name;
							let val = params.row.status;
							if (val == '1') {
								name = '已支付'
							} else if (val == '0') {
								name = '待支付'
							}  
							return h('span', name)
						}
					},
					{
						title: '支付实际',
						key: 'updateTime',
						align: 'center',
						width: 200,
					}
				]
			}
		},
		created() {
			this.getData();
		},
		methods: {
			change() {

			},
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			query(params) {
				this.queryParams = params
				this.refreshData()
			},
			getData() {
				const that = this
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize,
					...this.queryParams
				}
				api.statistics
					.goodBuyPage(queryParams)
					.then(res => {
						const result = res.data || {}
						that.totalRecord = result.totalRecordNum || 0
						that.queryData = result.records
					})
					.then(() => {
						that.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			changeRamrk(row) {
				const that = this
				api.statistics
					.updateUserTag({
						'id': row.id,
						userTag: row.userTag
					})
					.then(res => {
						that.$Message.success('Success!');

					})
			}

		},


	}
</script>